import { Button } from "antd";
import { ReactNode } from "react";
import { FiCheck } from "react-icons/fi";
import Spinner from "../components/Loading/Spinner";
import PrivacyPolicyLink from "./PrivacyPolicyLink";

interface ConfirmationScreenProps {
  vendorName: string | null;
  vendorLogo: string | null;
  organizationName: string | null;
  title: string;
  description: string | ReactNode;
  buttonText: string;
  onContinue: () => void;
}

export default function ConfirmationScreen({
  vendorName,
  vendorLogo,
  organizationName,
  title,
  description,
  buttonText,
  onContinue,
}: ConfirmationScreenProps) {
  if (!vendorName || !vendorLogo) {
    return <Spinner />;
  }

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
      }}>
      <div
        style={{
          height: 608,
          width: 360,
          backgroundColor: "white",
          borderRadius: 8,
          overflowX: "hidden",
          overflowY: "hidden",
        }}>
        <div
          style={{
            padding: "3.2rem",
            height: "100%",
            position: "relative",
          }}>
          <div className="flex flex-column items-center justify-center pb-4">
            <img
              style={{ height: 40, width: "auto", marginBottom: 20 }}
              src={vendorLogo}
              alt={`${vendorName} logo`}
            />
          </div>
          <div className="text-xl text-center">
            <div className="text-center">
              <span className="font-semibold">{title}</span>
              <br />
              <br />
              <div className="text-base">{description}</div>
            </div>
          </div>
          <div className="mt-8">
            <div>
              <div className="flex items-center">
                <FiCheck size={30} color="#62DAFF"></FiCheck>
                <div>
                  <div className="ml-3 text-lg">Secure</div>
                  <div className="ml-3">
                    Your data is handled securely with end-to-end encryption.
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="flex items-center">
                <FiCheck size={30} color="#62DAFF"></FiCheck>
                <div>
                  <div className="ml-3 text-lg">Private</div>
                  <div className="ml-3">
                    Your data will never be shared without your permission.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: "42px",
              marginBottom: ".8rem",
              marginRight: ".8rem",
              marginLeft: ".8rem",
            }}
            className="">
            <Button
              onClick={onContinue}
              style={{ marginTop: "auto" }}
              className="w-full"
              type="primary"
              size="large">
              {buttonText}
            </Button>
            <PrivacyPolicyLink actionText={buttonText} />
          </div>
        </div>
      </div>
    </div>
  );
}
